import { WeighingType } from './weighing-type.enum';

export class TransportWeighing {
  id: number;
  type: WeighingType;
  transportId: number;
  value: number;
  date: string;
  dateSortValue: number;
  source: string;
  autoWeight: number;
}
